import React, { createContext, useContext, useEffect, useState } from 'react';
import { FeatureFlags, getMyFlags } from '../services/featureFlagService';

interface FeatureFlagContextValue {
  flags: FeatureFlags;
  refreshFlags: () => Promise<void>;
}

const FeatureFlagContext = createContext<FeatureFlagContextValue>({
  flags: {},
  refreshFlags: async () => {},
});

export function FeatureFlagProvider({ children }: { children: React.ReactNode }) {
  const [flags, setFlags] = useState<FeatureFlags>({});

  const refreshFlags = async () => {
    try {
      const f = await getMyFlags();
      setFlags(f);
    } catch {
      setFlags({});
    }
  };

  useEffect(() => {
    refreshFlags();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FeatureFlagContext.Provider value={{ flags, refreshFlags }}>
      {children}
    </FeatureFlagContext.Provider>
  );
}

export function useFeatureFlag(key: string): boolean {
  const { flags } = useContext(FeatureFlagContext);
  return flags[key] ?? false;
}

export function useFeatureFlags(): FeatureFlagContextValue {
  return useContext(FeatureFlagContext);
}
